module.exports = __webpack_public_path__ + "c95cc5c77ee42df530d2c30fba34b9f9.svg";